module.exports = __webpack_public_path__ + "static/media/icon_nav_sales.736572f2.svg";